import React, { useRef } from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { DrawerBackdrop, DrawerWrapper, DrawerContainer } from './Drawer.elements'

// Utils
import { useOutsideAlerter } from 'common/utils/outsideAlerter'
import { useAnimatedMount } from 'common/utils/render'

function Drawer(props) {
  // Destructure
  const { anchor, open, onClose, children } = props

  // Refs
  const wrapperRef = useRef()

  // Hooks
  useOutsideAlerter(wrapperRef, () => {
    if (open === true) {
      onClose()
    }
  })
  const { shouldRender, animateIn } = useAnimatedMount(open, 300)

  return shouldRender ? (
    <DrawerBackdrop isOpen={animateIn}>
      <DrawerWrapper anchor={anchor} isOpen={animateIn} ref={wrapperRef}>
        <DrawerContainer isOpen={animateIn}>{children}</DrawerContainer>
      </DrawerWrapper>
    </DrawerBackdrop>
  ) : null
}

// Default Props
Drawer.defaultProps = {
  anchor: 'right',
  open: false,
  onClose: () => {},
  children: '',
}

// Proptypes Validation
Drawer.propTypes = {
  anchor: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
}

export default Drawer
